import * as React from 'react';
import { ArticleSuggestion } from './types/ArticleSuggestion';

interface ArticleProps {
    article: ArticleSuggestion;
    goToArticle(value: string): void;
}

// export class Article extends React.Component<ArticleProps> {
export class Article extends React.Component<ArticleProps> {
    constructor(props: ArticleProps) {
        super(props);
        this.handleArticleClick = this.handleArticleClick.bind(this);
    }

    render() {
        const { article } = this.props;
        return (
            <li
                className="article"
                onClick={this.handleArticleClick}
                key={`list-key-${article.id}`}
                id={`list-id-${article.id}`}
            >
                <a
                    className="article__article-link"
                    id={`anchor-id-${article.id}`}
                    key={`anchor-key-${article.id}`}
                >
                    {article.title}
                </a>
            </li>
        );
    }

    handleArticleClick(): void {
        const { article } =  this.props;
        return this.props.goToArticle(article.id);
    }
}

export default { Article };